import { writable } from 'svelte/store';
// export const token: Writable<Token | undefined> = writable({ id: "sdfdsf", ttl: 124, userId: 12 });
export const token = writable(undefined);
